
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="科目类别：">
                <el-select style="width: 100px;" size="small" v-model="formInline.subject" placeholder="请选择">
                    <el-option v-for="type in subject" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>


            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-edit" @click="upadd1()">科二考试规则</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-edit" @click="upadd2()">科二考试流程</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-edit" @click="upadd3()">科三考试规则</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="40">
            </el-table-column>
            <el-table-column prop="aid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="title" label="标题" width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="subject" label="科目" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.subject == 0">科目一</div>
                    <div v-else-if="row.subject == 1">科目二</div>
                    <div v-else-if="row.subject == 2">科目三</div>
                    <div v-else>科目四</div>
                </template>
            </el-table-column>
            <el-table-column prop="author" label="作者" width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="from" label="来源" width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="时间" width="140">
            </el-table-column>
            <el-table-column prop="content" label="文本内容" width="auto" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="describe" label="简短描述，标题" width="160" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="icon" label="封面图" width="100">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.icon" class="table_list_pic" :src="scope.row.icon"
                            :preview-src-list="[scope.row.icon]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="update(scope.row)"><i
                            class="el-icon-edit" />修改</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
        <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
        <Upadd1 :info="updateInfo1" :show.sync="dialog.upadd1DialogStatus"></Upadd1>
        <Upadd2 :info="updateInfo2" :show.sync="dialog.upadd2DialogStatus"></Upadd2>
        <Upadd3 :info="updateInfo3" :show.sync="dialog.upadd3DialogStatus"></Upadd3>
    </div>
</template>
  
<script>
import { getcheats, getdel, getartedit, getaddrules, getaddprocess } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Add from './add.vue'
import Update from './update.vue'
import Upadd1 from './upadd1.vue'
import Upadd2 from './upadd2.vue'
import Upadd3 from './upadd3.vue'
export default {
    // 注册组件
    components: {
        Pagination, Add, Update, Upadd1, Upadd2, Upadd3
    },
    data() {
        return {
            subject: [
                { key: '请选择', value: '' },
                { key: '科目一', value: 0 },
                { key: '科目二', value: 1 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '请选择', value: '' },
                { key: '真人讲解', value: 1 },
                { key: '学车视频', value: 5 },
            ],
            dialog: {
                addDialogStatus: false,
                updateDialogStatus: false,
                upadd1DialogStatus: false,
                upadd2DialogStatus: false,
                upadd3DialogStatus: false
            },
            updateInfo: {},
            updateInfo1: {},
            updateInfo2: {},
            updateInfo3: {},
            breadcrumbList: [],
            loading: false, //是显示加载
            formInline: {
                subject: '',
                limit: 10,
                page: 1
            },
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    mounted() {
        this.getdata()
        this.generateBreadcrumb()
    },
    watch: {
        $route() {
            this.generateBreadcrumb()
        }
    },
    methods: {
        add() {
            this.dialog.addDialogStatus = true
        },
        upadd1() {
            getaddrules({ subject: 1 }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.upadd1DialogStatus = true
                    this.updateInfo1 = res.msg
                }
            })
        },
        //考试流程
        upadd2() {
            getaddprocess({ subject: 1 }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.upadd2DialogStatus = true
                    this.updateInfo2 = res.msg
                }
            })
        },
        //考试流程
        upadd3() {
            getaddrules({ subject: 2 }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.upadd3DialogStatus = true
                    this.updateInfo3 = res.msg
                }
            })
        },
        update(row) {
            getartedit({ aid: row.aid, echo: 'get' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.updateDialogStatus = true
                    this.updateInfo = res.info
                }
            })
        },
        del(row) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getdel({ aid: row.aid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        search() {
            this.formInline.page = 1
            this.getdata(this.formInline)
        },
        generateBreadcrumb() {
            // 获取当前路由信息
            const matched = this.$route.matched
            console.log(matched, '++++++++++');
            // 初始化面包屑导航数据
            const breadcrumbList = []
            // 遍历路由信息，生成面包屑导航数据
            matched.forEach(item => {
                const { meta, name, path } = item
                if (meta.requireAuth) {
                    breadcrumbList.push({
                        name,
                        path
                    })
                }
            })
            console.log(breadcrumbList, '=========');
            // 保存面包屑导航数据
            this.breadcrumbList = breadcrumbList
        },
        getdata() {
            this.loading = true
            getcheats(this.formInline).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.listData = res.msg.data
                    this.pageparm.total = res.msg.total
                    this.loading = false

                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
  
<style scoped>
.videos {
    object-fit: contain;
    width: 100%;
    height: 50px;
}

.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/secret/index.vue